// frontend_react/src/services/receiptApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const processReceiptPayment = (
  receiptUuid,
  meansPayment,
  amount,
  checkFormat,
  { companyUuid } = {}
) =>
  api.post(
    `/receipt/${receiptUuid}/payment`,
    {
      means_payment: meansPayment,
      amount,
      check_format: checkFormat,
    },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const sendReceiptPdf = (uuid, format, { companyUuid } = {}) =>
  api.get(`/receipt/${uuid}/pdf`, {
    responseType: "blob",
    params: { format },
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const splitReceipt = ({
  original_receipt_uuid,
  items_splits,
  payments = [],
  companyUuid = null,
}) =>
  api.post(
    "/receipt/split",
    {
      original_receipt_uuid,
      items_splits,
      payments,
    },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export const fetchReceiptFull = (uuid, { companyUuid } = {}) =>
  api
    .get(`/receipt/${uuid}/full`, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);

export const fetchReceiptLines = (uuid, { companyUuid } = {}) =>
  api
    .get(`/receipt/${uuid}/lines`, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);

export const fetchReceiptPayments = (uuid, { companyUuid } = {}) =>
  api
    .get(`/receipt/${uuid}/payment`, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);

export const applyReceiptDiscount = (receiptUuid, payload, { companyUuid } = {}) =>
  api.post(`/receipt/${receiptUuid}/discount`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const printKitchenTicket = ({ receipt_uuid, companyUuid = null }) =>
  api.post(
    "/receipt/kitchen",
    { receipt_uuid },
    {
      headers: buildCompanyScopeHeaders(companyUuid),
    }
  );

export { splitReceipt as splitPayment };

export const listReceipts = ({ companyUuid, ...params } = {}) =>
  api
    .get("/receipt", {
      params,
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);

export const fetchReceiptAudit = (uuid, { companyUuid } = {}) =>
  api
    .get(`/receipt/${uuid}/audit`, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);

export const updateReceiptPaymentMeans = (
  receiptUuid,
  paymentUuid,
  payload,
  { companyUuid } = {}
) =>
  api
    .put(`/receipt/${receiptUuid}/payment/${paymentUuid}/means`, payload, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);

export const downloadReceiptPdf = async (receiptUuid, { companyUuid } = {}) => {
  const response = await api.get(`/receipt/${receiptUuid}/pdf`, {
    responseType: "blob",
    headers: buildCompanyScopeHeaders(companyUuid),
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", `ticket_${receiptUuid}.pdf`);
  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);
};

export const sendReceiptEmail = (receiptUuid, payload = {}, { companyUuid } = {}) =>
  api
    .post(`/receipt/send_email/${receiptUuid}`, payload, {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((res) => res.data);
// ============================================================
// LOT 12.8.9.3 — RETURN / REFUND RUNTIME TRANSPORT
// ============================================================


export const fetchReceiptReturns = (
  receiptUuid,
  {
    companyUuid,
  } = {}
) =>
  api
    .get(
      `/receipt/${receiptUuid}/returns`,
      {
        headers:
          buildCompanyScopeHeaders(
            companyUuid
          ),
      }
    )
    .then(
      (res) =>
        res.data
    );


export const createReceiptReturn = (
  receiptUuid,
  payload,
  {
    companyUuid,
  } = {}
) =>
  api
    .post(
      `/receipt/${receiptUuid}/returns`,
      payload,
      {
        headers:
          buildCompanyScopeHeaders(
            companyUuid
          ),
      }
    )
    .then(
      (res) =>
        res.data
    );


export const fetchReceiptRefunds = (
  receiptUuid,
  {
    companyUuid,
  } = {}
) =>
  api
    .get(
      `/receipt/${receiptUuid}/refunds`,
      {
        headers:
          buildCompanyScopeHeaders(
            companyUuid
          ),
      }
    )
    .then(
      (res) =>
        res.data
    );


export const createReceiptRefund = (
  receiptUuid,
  payload,
  {
    companyUuid,
  } = {}
) =>
  api
    .post(
      `/receipt/${receiptUuid}/refunds`,
      payload,
      {
        headers:
          buildCompanyScopeHeaders(
            companyUuid
          ),
      }
    )
    .then(
      (res) =>
        res.data
    );
